export default "__VITE_ASSET__3f470f1c__"